<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import type { FormItemRule } from "@nutui/nutui/dist/types/__VUE/form/types";
import { computed, inject } from "vue";

interface Rule {
  regExp: string;
  message: string;
}

const props = withDefaults(
  defineProps<{
    required: boolean;
    requiredErrorMessage?: string;
    rules?: Rule[];
    prop?: string;
  }>(),
  { rules: () => [] }
);

const formItemRules = computed(() => {
  const list: FormItemRule[] = [];
  if (props.required) {
    list.push({
      required: true,
      message: props.requiredErrorMessage || "请输入",
    });
  }

  if (props.rules) {
    props.rules.forEach((rule) =>
      list.push({ regex: new RegExp(rule.regExp), message: rule.message })
    );
  }
  return list;
});

const parentValidate = inject<(prop?: string) => any>("validate")!;
async function validate() {
  if (!props.prop) return true;
  const res = await parentValidate(props.prop);
  return res;
}

defineExpose({ validate });
</script>
<template>
  <nut-form-item
    v-bind="$attrs"
    :required="required"
    :prop="prop"
    :rules="formItemRules"
  >
    <template #label v-if="$slots.label"><slot name="label" /></template>
    <template #default v-if="$slots.default"> <slot name="default" /></template>
  </nut-form-item>
</template>
